<script>
import {authComputed, productMethods} from '@state/helpers'
import PurchaseDialog from '@components/purchase-dialog.vue'

export default {
  components: { PurchaseDialog },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayProduct: this.product,
      isWorking: false,
      error: null,
      dialog: false,
    }
  },
  computed: {
    ...authComputed,
    availableLink() {
      const filter = this.product.links.filter((x) => x.available === true)
      if (filter.length > 0) {
        return filter[0]
      }

      return null
    },
    lastCheckedString() {
      let maxItem = this.product.links[0]
      this.product.links.forEach((x) => {
        const time1 = parseInt(x.lastChecked)
        const time2 = maxItem ? maxItem.lastChecked : 0
        if (time1 > time2) {
          maxItem = x
        }
      })

      if (!maxItem) {
        return `Unknown`
      }

      return `${new Date(
        parseInt(maxItem.lastChecked)
      ).toLocaleString()}`
    },
    productImage() {
      const itemsWithImage = this.product.links.filter(x => x.image && !x.isBundle);
      if (itemsWithImage.length === 0) {
        return null
      }

      return itemsWithImage[0].image
    }
  },
  methods: {
    ...productMethods,
    goToProduct() {
      this.$router.push({
        name: 'view-product',
        params: { productId: this.product.id },
      })
    },
    subscribeUnsubscribe() {
      this.isWorking = true
      if (this.product.isSubscribed) {
        this.unsubscribeToProduct({ productId: this.product.id })
          .then(() => {
            this.displayProduct.isSubscribed = false
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              if (err.response.data.message) {
                this.$swal
                    .fire({
                      title: 'Error!',
                      text: err.response.data.message,
                      icon: 'error',
                      confirmButtonText: 'Go to Settings',
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        this.$router.push({ name: 'profile' })
                      }
                    })

                return
              }

              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      } else {
        this.subscribeToProduct({ productId: this.product.id })
          .then(() => {
            this.displayProduct.isSubscribed = true
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              if (
                err.response.data.message.toLowerCase().indexOf('drops') !== -1
              ) {
                this.dialog = true
                return
              }

              if (err.response.data.message) {
                if (err.response.data.message.indexOf('active subscription') !== -1 && this.isAppLogin) {
                  window.location.href = 'https://app.inventorybot.io/app/appRoutes/needSubscription';
                } else {
                  this.$swal
                      .fire({
                        title: 'Error!',
                        text: err.response.data.message,
                        icon: 'error',
                        confirmButtonText: 'Go to Settings',
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          this.$router.push({name: 'profile'})
                        }
                      })
                }

                return
              }

              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      }
    },
  },
}
</script>

<template>
  <v-flex xs12 class="mb-5">
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 12 : 2"
        shaped
        :class="{ 'on-hover': hover }"
        @click="goToProduct"
      >
        <div class="d-flex flex-no-wrap align-items-center">
          <v-avatar class="ma-3" size="125" tile>
            <v-img v-if="!productImage" src="@assets/images/default_product_image.jpg"></v-img>
            <v-img v-else :src="productImage"></v-img>
          </v-avatar>

          <div>
            <v-card-title :class="$style.productTitle">{{
              product.name
            }}</v-card-title>
            <v-card-subtitle>
              <span v-if="!availableLink">Unavailable</span>
            </v-card-subtitle>

            <v-card-actions>
              <BaseButton
                v-if="!displayProduct.isSubscribed"
                :disabled="isWorking"
                @click.stop="subscribeUnsubscribe"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
                  Subscribe to Product
                </span>
              </BaseButton>

              <BaseButton
                v-if="displayProduct.isSubscribed"
                :disabled="isWorking"
                @click.stop="subscribeUnsubscribe"
              >
                <BaseIcon v-if="isWorking" name="sync" spin />
                <span v-else>
                  Unsubscribe from Product
                </span>
              </BaseButton>
              <p v-if="error">
                {{ error }}
              </p></v-card-actions
            >
          </div>
        </div>
      </v-card>
    </v-hover>

    <v-dialog v-model="dialog" max-width="600px">
      <PurchaseDialog title="Need more Drops?"></PurchaseDialog>
    </v-dialog>
  </v-flex>
</template>

<style lang="scss" module>
@import '@design';

.productCell {
  cursor: pointer;
}

.productTitle {
  word-break: normal;
}
</style>
